module.exports = __webpack_public_path__ + "static/media/no_notification.9a723c40.svg";